<template>
  <div class="table-responsive">
    <table class="table" :class="table_class" :id="table_id">
      <thead>
        <tr>
          <th
            v-for="(item, index) in data_head"
            :key="index"
            :class="setClass(item)"
          >
            {{ item }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="data_body == null">
          <td :colspan="data_head.length">
            <loader-component />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import $ from "jquery";
import loader_component from "@/views/components/loader.vue";
import datatable from "datatables/media/js/jquery.dataTables.min.js";
$.DataTable = datatable;
import "datatables/media/css/jquery.dataTables.min.css";

export default {
  name: "table_dynamic",
  components: {
    "loader-component": loader_component,
  },
  props: {
    data_head: Array,
    data_body: Array,
    data_head_class: {
      type: Array,
      default: function () {
        return [];
      },
    },
    config: {
      type: Object,
      default: function () {
        return null;
      },
    },
    table_class: String,
    table_id: {
      type: String,
      default: function () {
        return "table-dynamic";
      },
    },
  },
  data() {
    return {
      table: null,
      conf: {
        language: {
          search: "Cari:",
          zeroRecords: "Data tidak tersedia",
          info: "Menampilkan halaman _PAGE_ dari _PAGES_",
          infoEmpty: "Menampilkan 0 data",
          lengthMenu: "Tampilkan _MENU_ data",
          paginate: {
            next: "Lanjut",
            previous: "Sebelum",
          },
        },
        pageLength: 5,
        lengthMenu: [5, 10, 25, 50, 75, 100],
        aaSorting: [[1, "desc"]],
      },
    };
  },
  methods: {
    loadData: function () {
      if (this.data_body != null) {
        if (this.data_body.length > 0) {
          this.table.clear();
          for (let index in this.data_body) {
            this.table.row.add(this.data_body[index]).node().id = index;
            this.table.draw(false);
          }
        }
      }
    },
    setClass(head) {
      if (this.data_head_class.length > 0) {
        let head_class = this.data_head_class.find((el) => el.head == head);
        if (head_class) {
          return head_class.class;
        }
        return "";
      }
      return "";
    },
  },
  mounted: function () {
    if (this.data_body) {
      if (this.config) {
        this.table = $("#" + this.table_id).DataTable(this.config);
      } else {
        this.table = $("#" + this.table_id).DataTable(this.conf);
      }
      this.loadData();
    }
  },
};
</script>

<style>
.table td,
.table th {
  padding-left: 15px;
}
.table td {
  padding: 10px 15px;
}
.table tbody tr td {
  padding: 8px 10px !important;
}
table.dataTable tbody td,
table.dataTable tbody th {
  padding: 8px 10px !important;
}
</style>